import { combineReducers } from "@reduxjs/toolkit";
import transactionHistoryReducer from "./transactionHistory";
import suspectTransactionReducer from "./transactionSuspect";

const danaReducer = combineReducers({
    transactionHistory: transactionHistoryReducer,
    suspectTransaction: suspectTransactionReducer,
})

export default danaReducer;